<template>
    <div v-if="viewMode === null" style="background:white;">
        <simple :showCheckbox="showCheckbox" :cat-node="catNode" :parent-node="parentNode" :show-node="showNode" :is-allowed="isAllowed"
            :show-child="showChild" :has-childs="hasChilds" v-on:catClicked="currentCatClicked" v-on:expandClick="expandClick">
        </simple>
        <simple-child :show-node="showNode" :show-child="showChild" v-for="child in catNode.childs">
            <category-tree :showCheckbox="showCheckbox" :cat-node="child" @catSelected="catClicked" :parent-node="catNode" v-on:bubble="onBubble"
                :selected="selected" :parent-selected="isAllowed" :expand-all="expandAll" @parentBlocking="onParentBlocking"
                :parentLevel="level"></category-tree>
        </simple-child>
    </div>
    <div :style="(viewMode.wrapStyle)" v-else-if="!hideCurrentNode">
            <div style="display: inline-block;" :style="{color:(isAllowed?'green':'')}" v-if="showNode">
                <span v-if="showExpandSign" style="display: inline-block;height: 14px;width: 14px;">
                    <span style="cursor:pointer;" class="glyphicon"
                        :class="{ 'glyphicon-triangle-right': !showChild, 'glyphicon-triangle-bottom': showChild }"
                        @click="expandClick" v-if="hasChilds"></span>
                </span>
                <span :class="viewMode.nameClass" class="btn" style="cursor: pointer;padding: 4px 4px;"
                    @click="currentCatClicked" :style="{color:(isAllowed?'green':'')}">
                        <span class="glyphicon glyphicon-ok" v-if="isAllowed" style="padding:0px 2px;"></span>
                    <span><span v-if="hasChilds" class="glyphicon glyphicon-th-large"></span> {{ catNode.name }}</span>
                    <span v-if="!hasChilds && catNode.itemCounts!==null" style="border-left: 1px solid gray;margin-left: 6px;padding: 6px;" class="agx-theme-bg">{{catNode.itemCounts}}</span>
                </span>
            </div>
            <div style="margin-left:15px;" :style="{ display: showChild ? '' : 'none' }">
                <template v-for="child in catNode.childs">
                    <category-tree :hide-zero-counts="hideZeroCounts" :cat-node="child" @catSelected="catClicked"
                    :parent-node="catNode" v-on:bubble="onBubble" :selected="selected" :parent-selected="isAllowed"
                    :expand-all="expandAll" :parentLevel="level" @parentBlocking="onParentBlocking" :showExpandSign="showExpandSign"
                    :viewMode="{ ...viewMode, 
                        wrapStyle: getWrapStyle(child), 
                        nameClass: getNameClass(child)}">
                        </category-tree>
                </template>
            </div>
    </div>
</template>
<script>

import simple from "./treeviews/simple.vue"
import simpleChild from "./treeviews/simpleChild.vue"
export default {
    components: {
        simple: simple,
        simpleChild: simpleChild,
        categoryTree: () => import('./CategoryTree.vue')
    },
    props: {
        "catNode": Object,
        "showNode": { type: Boolean, default: true },
        "expandChild": { type: Boolean, default: false },
        "expandAll": { type: Boolean, default: false },
        "parentNode": { type: Object, default: null },
        "selected": {
            type: Object,
            default() {
                return { catIds: [], timestamp: 0 };
            }
        },
        "parentSelected": { type: Boolean, default: false },
        "parentLevel": { type: Number },
        "viewMode": { type: Object, default: null },
        "showCheckbox":{type:Boolean,default:true},
        "showExpandSign":{type:Boolean,default:true},
        "reloadState":{type:Number},
        "hideZeroCounts":{type:Boolean,default:false}
    },
    computed: {
        hideCurrentNode(){
            //return (hideZeroCounts && (catNode.itemCounts == null || catNode.itemCounts == 0)) || hasChilds;
            return (this.hideZeroCounts && (this.catNode.itemCounts == null || this.catNode.itemCounts == 0)) && !this.hasChilds;
        },
        hasChilds() {
            return this.catNode.childs.length > 0;
        },
        isLastParent() {
            if (!this.catNode.childs) return false;
            var length = this.catNode.childs.length;
            if (length > 0) {
                var count = 0;
                for (var i = 0; i < length; i++) {
                    var grandChilds = this.catNode.childs[i].childs;
                    if (grandChilds.length === 0) {
                        count += 1;
                    }
                }
                if (count === length) return true;
            }
            return false;
        },
        level() {
            if (this.parentLevel) {
                return this.parentLevel * 1 + 1;
            } else {
                if (this.parentLevel === 0) {
                    return 1;
                }
                return 0;
            }
        },
        isSelected() {
            if (this.selected.catIds.length > 0 && this.catNode !== null) {
                return this.selected.catIds.indexOf(this.catNode.catId) >= 0;
            }
            return false;
        },
        isAllowed() {
            return this.parentSelected || this.isSelected;
        }
    },
    data: function () {
        return {
            showChild: false
        };
    },
    methods: {
        getNameClass(node){
            if(node.childs.length > 0){
                return '';
            }
            return 'btn btn-default';
        },
        getWrapStyle(node){
            let style= {marginBottom:'5px'};
            let hasChilds = node.childs.length > 0;
            if(hasChilds){
                 style.display = '';
            }else{
                style.display = 'inline-block';
                style.marginRight = '5px';
            }
            return style;
        },
        getDecendents(startNode){
            function getDec(cat){
                var ret = [];
                if(cat.childs && cat.childs.length>0){
                    cat.childs.forEach(c=>{
                        ret.push(c);
                        var grandChilds = getDec(c);
                        ret = [...ret,...grandChilds];
                    });
                }
                return ret;
            }
            var ret = getDec(startNode);
            return ret;
        },
        expandClick() {
            this.showChild = !this.showChild;
            this.$emit("expandClick");
        },
        onParentBlocking(info){
            if(this.isSelected){
                this.currentCatClicked();
            }else{
                this.$emit("parentBlocking",info);
            }
        },
        currentCatClicked(){
            var node = this.catNode;
            if(this.parentSelected){
                this.$emit("parentBlocking",{node:node});
                return;//if parent selected, no need to select child items
                //proprogate to de-select parent first
            }
            var decendents = this.getDecendents(node);
            console.log("decendents",decendents);
            this.catClicked({child:node,parent:this.parentNode,decendents:decendents});
        },
        catClicked(catPair) {
            this.$emit("catSelected", catPair);
        },
        bubbleUp(val) {
            this.$emit("bubble", val);
        },
        onBubble(val) {
            this.showChild = true; console.log("show true on bubble", this.catNode.name);
            this.bubbleUp(val);
        },
        bubbleSelection() {
            if (this.isSelected) {
                this.bubbleUp("selection");
            }
        },
        loadState(){
            this.showChild = this.expandChild === true || this.expandAll === true;
        }
    },
    watch: {
        'selected'() {
            this.bubbleSelection();
        },
        'reloadState'(){
            console.log('reloadState',this.catNode);
            this.loadState();
        }
    },
    created: function () {
        this.loadState();
    },
    mounted: function () {
        this.bubbleSelection();
    },
    destroyed: function () {

    }
}
</script>